import type { SpearheadArmyId } from "./aos4spearhead";
import type { IPublicMatch } from "./match";
import type { IPlayer } from "./player";
import type { GameRuleId, SpearheadGameRuleState, TerrainFeatureSetup, TerrainFeaturesSetId } from "./rules";

/** Action description. */
export interface Action {
  /** TODO: The player deploys their army. */
  deploy?: boolean;

  /** The player choses their enhancements. */
  enhancements?: number[];

  /** The player choses a map property. */
  map?: Partial<SpearheadGameRuleState["map"]>;

  /** The player choses their role. */
  role?: 1 | 2;

  /** The player rolls. */
  roll?: boolean;

  /** The player choses a Terrain Feature Set. */
  terrainFeatures?: TerrainFeatureSetup[];

  /** The player choses a Terrain Feature Set. */
  terrainSet?: TerrainFeaturesSetId;
}

/** Settings chosen by the player to enter match queue. */
export interface QueueSettings {
  /** Chosen army. */
  armyId: SpearheadArmyId;

  /** Chosen army for development GameRules. */
  devArmyId?: SpearheadArmyId;

  /** Chosen GameRule. */
  ruleId: GameRuleId;
}

export interface WSRequest {
  /** The action performed by the player. */
  action?: Action;

  /** Availability check answer. */
  available?: boolean;

  /** Player want to check for displayName availability. */
  checkDisplayName?: string;

  /** Sent at connection login. */
  clientId?: string;

  /** The same clientId is connected twice. */
  doubleConnection?: boolean;

  /** Interact with matches */
  match?: {
    /** Match details. */
    details?: IPublicMatch | null;

    /** Viewer wants to see match details. */
    matchId?: string;
  };

  /** Server updates player. */
  player?: IPlayer;

  /** Find match queue management. */
  queue?: {
    /** Player wants to find a match. */
    enterQueue?: QueueSettings;

    /** Player wants to stop finding a match. */
    exitQueue?: boolean;

    /** Player is in queue to find a match. */
    inQueue?: boolean;

    /** The match started. */
    matchId?: string;
  };

  /** Player wants to set their displayName. */
  setDisplayName?: string;

  /** The game state update. */
  update?: string;
}

export const WSRequest = { stringify: JSON.stringify as (request: WSRequest) => string };

export interface RawWSRequest extends WSRequest {
  answerTo?: number;
  requestId: number;
}

export const RawWSRequest = {
  parse:     JSON.parse as (request: string) => RawWSRequest,
  stringify: JSON.stringify as (request: RawWSRequest) => string
};
